import { CircularProgress } from '@material-ui/core';
import React from 'react';

export interface AnalysisChartLoadingProps {
  heightClass?: string;
}

export const AnalysisChartLoading: React.FC<AnalysisChartLoadingProps> = ({
  heightClass = 'h-[520px]',
}) => {
  return (
    <div className={`${heightClass} w-full flex justify-center items-center px-8 gap-4`}>
      <CircularProgress classes={{ circle: 'text-gray-300' }} />
    </div>
  );
};

export default AnalysisChartLoading;
